import React, { useContext } from 'react';
import { shape as shapeType, string as stringType } from 'prop-types';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import { ExperienceContext } from '@thd-nucleus/experience-context';

const BannerRenderer = ({ data, desktopAspectRatio, mobileAspectRatio }) => {
  const { channel } = useContext(ExperienceContext);

  const {
    link
  } = data?.component || {};

  const isSSR = typeof window === 'undefined';

  let contentToRender;
  if (isSSR) {
    contentToRender = (
      <LoadingPlaceholder
        type="rect"
        color="#E0E0E0"
        showLoadingAnimation
        ready={false}
        style={{
          height: '100%',
          width: '100%'
        }}
      />
    );
  } else {
    const retrieveUrl = (previewImage) => {
      let url = '';
      if (previewImage) {
        const damDownloadedContentImage = previewImage.damDownloadedContent;
        const damContentSelectorImage = previewImage.damContentSelector?.assetData?.[0];

        if (damDownloadedContentImage?.url) {
          url = damDownloadedContentImage?.url;
        } else {
          url = damContentSelectorImage?.selectedImageUrl;
        }
      }
      return url;
    };

    const mobilePreviewImage = data?.component?.mobileImage || {};
    const tabletPreviewImage = data?.component?.tabletImage || {};
    const desktopPreviewImage = data?.component?.desktopImage || {};

    const mobileUrl = retrieveUrl(mobilePreviewImage);
    const tabletUrl = retrieveUrl(tabletPreviewImage);
    const desktopUrl = retrieveUrl(desktopPreviewImage);

    contentToRender = (
      <a href={link}>
        <img className="sui-block md:sui-hidden" src={mobileUrl} alt="banner" height="100%" width="100%" />
        {/* eslint-disable-next-line max-len */}
        <img className="sui-hidden md:sui-block xl:sui-hidden" src={tabletUrl} alt="banner" height="100%" width="100%" />
        <img className="sui-hidden xl:sui-block" src={desktopUrl} alt="banner" height="100%" width="100%" />
      </a>
    );
  }

  const aspectRatio = channel === 'desktop' ? desktopAspectRatio : mobileAspectRatio;
  const placeholderStyles = { aspectRatio };

  return (
    <div className="internal-marketing-banner" style={placeholderStyles}>
      {contentToRender}
    </div>
  );
};

BannerRenderer.propTypes = {
  data: shapeType({}),
  desktopAspectRatio: stringType.isRequired,
  mobileAspectRatio: stringType.isRequired
};

BannerRenderer.defaultProps = {
  data: {}
};

BannerRenderer.displayName = 'BannerRenderer';

export { BannerRenderer };